module.exports = {
     base_url:"https://engine.shurjopayment.com/api/",
     image_base_url:"https://engine.shurjopayment.com/",
     merchant_logo_image_base_url:"https://admin.shurjopayment.com/",
     cancel_base_url:"https://engine.shurjopayment.com/",
     customer_api_base_url:"https://engine.shurjopayment.com/customer-api/",
}
